import React from 'react';
import {formatData} from "../../js/shared-functions";

export default class DpcElencoCardImage extends React.Component {

    getText(text){
        if(!text || typeof text !== "string")
            return "";

        const regex = /(( ?)<\/?(?:a)[^>]*>)|<[^>]+>( ?)/ig;
        const subst = `$1`;
        const body = text.replace(regex, subst);

        if(body.length <= 140)
            return body;
        const subString = body.substr(0, 139);
        return subString.substr(0, subString.lastIndexOf(" ")) + "...";
    }

    render(){
        return (
            <div className="col-12 col-md-6">
                <div className="card w-100">
                    <div className="row">
                        <div className="col-12 col-xl-6">
                            <a href={this.props.slug}>
                            <img
                                src={this.props.image?.localFile?.publicURL}
                                className="card-img" alt={this.props.altImage}/>
                            </a>
                        </div>
                        <div className="col-12 col-xl-6">
                            <div className="card-body">
                            
                                <span className="data">{formatData(this.props.data_creazione, this.props.dataFormat, this.props.lang)}</span>
                            
                                <h5 className="card-title"><a href={this.props.slug}>{this.props.title}</a></h5>
                                <p className="card-text" dangerouslySetInnerHTML={{__html: this.getText(this.props.body)}}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}
